import { Info } from "lucide-react";
import { cn } from "@/utils/cn";

interface InfoTooltipProps {
  text: string;
}

export function InfoTooltip({ text }: InfoTooltipProps) {
  return (
    <span className="group relative inline-flex shrink-0 items-center">
      <Info className="h-3 w-3 cursor-help text-slate-400" aria-label={text} />
      <span
        role="tooltip"
        className={cn(
          "pointer-events-none absolute left-1/2 bottom-full z-10 mb-1 w-60 -translate-x-1/2",
        //   "rounded-md bg-slate-800 px-3 py-2 text-xs leading-relaxed text-white shadow-lg",
          "invisible opacity-0 transition-opacity group-hover:visible group-hover:opacity-100"
        )}
      >
        {text}
      </span>
    </span>
  );
}
